import get from 'lodash/get';
import set from 'lodash/set';
import * as jwNewestVideoActions from '../../action_creators/video/jw_newest_video_action_creators';
import JwPlaylistModel from '../../../models/video/jw_playlist_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchJwNewestVideoDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(jwNewestVideoActions.jwNewestVideoLoading({}, store));

    // we override the id here for the newest playlist
    set(params, 'playlistId', 'Y4a4AwUd');

    return JwPlaylistModel.fetch(params, store)
      .then(function handleJwNewestVideoDetailData(JwNewestVideoData) {
        dispatch(
          jwNewestVideoActions.jwNewestVideoLoaded(
            JwNewestVideoData.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in jwNewestVideo actions, message: ${err.message}`
          );
        }

        dispatch(jwNewestVideoActions.jwNewestVideoLoadError(err, store));
      });
  };
}
